import React, { useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material/Select';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import useMediaContext from '../../../../../../hooks/useMediaContextHook/useMediaContext';

const marketOptions = [
  { key: 'en', text: 'English', value: 'EN', icon: 'assets/icons/en.svg', iso: 'en-us' },
  { key: 'de', text: 'Deutsch', value: 'DE', icon: 'assets/icons/de.svg', iso: 'de' },
  { key: 'nl', text: 'Nederlands', value: 'NL', icon: 'assets/icons/nl.svg', iso: 'nl' },
  { key: 'uk', text: 'Ukrainian', value: 'UA', icon: 'assets/icons/ua.svg', iso: 'uk' },
];

interface MarketSelectorProps {
  size?: string;
}

const MarketSelector: React.FC<MarketSelectorProps> = ({ size = 'small' }) => {
  const { t, i18n } = useTranslation();
  const { selectedOption, setSelectedOption } = usePractitionerControlsContext();
  const { setDiveIndex } = useMediaContext();
  const handleSelect = async (event: SelectChangeEvent<string>) => {
    setDiveIndex([]);
    const newLang = event.target.value;

    setSelectedOption(newLang);
    await i18n.changeLanguage(newLang);
  };

  return (
    <Tooltip title={t('language') as string} placement={'left'}>
      <FormControl className={`market-form`}>
        <Select
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
          value={selectedOption}
          onChange={handleSelect}
          renderValue={() => {
            return (
              <img
                className={'icon'}
                height={20}
                width={20}
                src={marketOptions.find(o => o.key === selectedOption)?.icon}
                alt={''}
              />
            );
          }}
        >
          {marketOptions.map((option: any) => (
            <MenuItem value={option.key} key={option.key}>
              <img className={'icon'} height={20} width={20} src={option.icon} alt={''} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default MarketSelector;
